import type { FormField } from '../../contexts';

export const checkUpdatedFields = (
  prevFields: FormField[],
  currentFields: FormField[]
): boolean => {
  if (prevFields.length !== currentFields.length) {
    return true;
  }

  const prevFieldsMap = new Map<string, FormField>(
    prevFields.map((field) => [field.id, field])
  );

  return currentFields.some((field) => {
    const prevField = prevFieldsMap.get(field.id);

    if (!prevField) {
      return true;
    }

    return Object.keys(field).some((key) => {
      const fieldKey = key as keyof FormField;
      return field[fieldKey] !== prevField[fieldKey];
    });
  });
};
